@if (loading()) {
	<nz-spin nzSimple nzSize="small"></nz-spin>
} @else {
	@if (user(); as user) {
		<nz-tag
			[nzColor]="BEFORE_AFTER_STATUS_UNCHANGED_COLOR"
			[nz-tooltip]="'The user is currently enrolled in this many sections.'"
		>
			{{ existing() }}
		</nz-tag>
		<nz-tag
			[nzColor]="BEFORE_AFTER_STATUS_NEW_COLOR"
			[nz-tooltip]="'How many new sections will the user be enrolled in.'"
		>
			{{ added() }}
		</nz-tag>
		<nz-tag
			[nzColor]="BEFORE_AFTER_STATUS_REMOVED_COLOR"
			[nz-tooltip]="'How many sections will be removed from the user.'"
		>
			{{ removed() }}
		</nz-tag>
		@if (enableEditButton()) {
			<button
				nz-button
				nzType="primary"
				nzSize="small"
				(click)="editUser(user)"
				nzShape="circle"
				nz-tooltip="Edit the user and sections"
			>
				<nz-icon nzType="edit" />
			</button>
		}
	}
}
